/* UTILS */
import { nextTick } from "vue"
import { setup, createActor } from "xstate"
import router from "@/router"
import { globalActor } from "@/machines/globalMachine"
import { useCookies } from "@vueuse/integrations/useCookies.js"
import { COOKIES } from "@/config/constants"

/* STORES */
import { storeToRefs } from "pinia"
import { useUserStore } from "@/stores/user"

/* TYPES */
import { type GlobalMachineEvent } from "@/machines/types"

export const meetingMachine = setup({
  types: {} as {
    events: any
  },
  actions: {},
}).createMachine({
  id: "meetingMachine",
  initial: "book",
  states: {
    book: {
      entry: [() => router.replace({ name: "meeting" })],
      on: {
        done: { target: "final" },
      },
    },
    final: {
      type: "final",
    },
  },
})

export const meetingActor = createActor(meetingMachine)

meetingActor.subscribe({
  async complete() {
    const { fetchNextAssessment } = useUserStore()
    const { nextAssessmentName } = storeToRefs(useUserStore())

    const workflow_uuid = useCookies().get(COOKIES.WORKFLOW_UUID)
    await fetchNextAssessment(workflow_uuid ?? null)

    await nextTick()

    if (nextAssessmentName.value) {
      globalActor.send({
        type: `GLOBAL.REDIRECT.${nextAssessmentName.value.toUpperCase()}` as GlobalMachineEvent,
      })
    } else {
      useCookies().remove(COOKIES.WORKFLOW_UUID, COOKIES.OPTIONS)
      useCookies().remove(COOKIES.PM_UUID, COOKIES.OPTIONS)
      useCookies().remove(COOKIES.COMPANY_UUID, COOKIES.OPTIONS)
      globalActor.send({ type: "GLOBAL.MEETING.DONE" })
    }
  },
})
